<template>
  <div>
    <Collapse v-model="value" simple style="border: 0; margin-bottom: 30px">
      <Panel
        name="1"
        hide-arrow
        style="margin: 20px 0; border: 0"
        v-show="endType.includes('绩效重点')"
      >
        <FormTitle
          :titleText="$t('Performance_Priorities_WHAT_')"
        /><!-- 绩效重点(WHAT) -->
        <div slot="content" style="margin-top: 20px">
          <div v-show="endType.includes('绩效重点')">
            <!-- 绩效重点(WHAT) -->{{ $t("Performance_Priorities_WHAT_") }}
          </div>
          <PersonalGoals
            v-show="endType.includes('绩效重点')"
            ref="PersonalGoals"
            :tabName="'yearEndSummary'"
          ></PersonalGoals>
        </div>
      </Panel>

      <Panel
        name="6"
        hide-arrow
        style="margin: 20px 0; border: 0"
        v-show="endType.includes('STI')"
      >
        <FormTitle :titleText="$t('STI_Self')" /><!-- STI个人目标 -->
        <div slot="content" style="margin-top: 20px">
          <div v-show="endType.includes('STI')">
            <!-- STI个人目标 -->{{ $t("STI_Self") }}
          </div>
          <STIComponent
            v-show="endType.includes('STI')"
            ref="STIComponent"
            :tabName="'yearEndSummary'"
          ></STIComponent>
        </div>
      </Panel>
      <Panel
        name="2"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="endType.includes('行为期望')"
      >
        <FormTitle
          :titleText="$t('Behavioural_Expections_How_')"
        /><!-- 行为期望(HOW) -->
        <div style="margin-top: 30px" slot="content">
          <BehaviorExpectation
            ref="BehaviorExpectation"
            :tabName="'yearEndSummary'"
          ></BehaviorExpectation>
        </div>
      </Panel>
      <Panel
        name="7"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="endType.includes('增长文化')"
      >
        <FormTitle
          :titleText="$t('Behavioural_Expections_How_')"
        /><!-- 增长文化 -->
        <div style="margin-top: 30px" slot="content">
          <GrowthCulture
            ref="GrowthCulture"
            :tabName="'yearEndSummary'"
          ></GrowthCulture>
        </div>
      </Panel>
      <Panel
        name="3"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="
          endType.includes('个人发展计划') ||
          endType.includes('能动性及职业发展')
        "
      >
        <FormTitle :titleText="$t('longText11')" />
        <!-- 员工发展计划（需要考虑与3A行为准则或专业技能的差距，基于70/20/10原则，并根据实际情况进行填写发展行动中的在岗培训和经验/向他人学习/正式领导培训/正式业务培训/其他） -->
        <div slot="content" style="margin-top: 20px">
          <div v-show="endType.includes('个人发展计划')">
            <!-- 个人发展计划 -->{{ $t("Development_Plans") }}
          </div>
          <div v-show="endType.includes('个人发展计划')" style="margin: 30px 0">
            <DevelopmentPlan
              ref="DevelopmentPlan"
              :tabName="'yearEndSummary'"
            ></DevelopmentPlan>
          </div>

          <div v-show="endType.includes('能动性及职业发展')">
            {{ $t("Mobility_and_Career_Aspirations_")
            }}<!-- 能动性及职业发展意向 -->
          </div>
          <Divider />
          <div
            v-show="endType.includes('能动性及职业发展')"
            style="margin-top: 30px"
          >
            <Form
              label-position="left"
              slot="content"
              :model="formItem"
              style="margin: 30px 5px 0 5px"
              :rules="ruleValidate"
              ref="formValidate"
              :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
            >
              <Row :gutter="40">
                <Col :xs="24" :sm="24" :md="12" :lg="7">
                  <FormItem
                    :label="$t('Mobility_Be_Have')"
                    :label-width="140"
                    v-if="formCheck"
                    :prop="
                      (applyEditFlag == '0' || userDeptFlag == '1') &&
                      status < 5
                        ? 'beInitiative'
                        : ''
                    "
                    ><!-- 是否有能动性 -->
                    <Select
                      v-model="formItem.beInitiative"
                      @on-change="formCheckChange"
                      clearable
                    >
                      <Option
                        v-for="item in YesOrNoList"
                        :value="item.code"
                        :key="item.code"
                        >{{
                          lang == "zh" ? item.ch_value : item.en_value
                        }}</Option
                      >
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row :gutter="40">
                <Col :xs="24" :sm="24" :md="12" :lg="7">
                  <FormItem
                    :label="$t('Cross-Region')"
                    :label-width="140"
                    v-if="formCheck"
                    :prop="
                      formItem.beInitiative == '1' && status < 5
                        ? 'crossRegion'
                        : ''
                    "
                    ><!-- 跨地域 -->
                    <Select v-model="formItem.crossRegion" clearable>
                      <Option
                        v-for="item in CrossRegional"
                        :value="item.code"
                        :key="item.code"
                        >{{
                          lang == "zh" ? item.ch_value : item.en_value
                        }}</Option
                      >
                    </Select>
                  </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="12" :lg="6">
                  <FormItem
                    :label="$t('Cross-Function')"
                    :label-width="100"
                    v-if="formCheck"
                    :prop="
                      formItem.beInitiative == '1' && status < 5
                        ? 'crossFunList'
                        : ''
                    "
                    ><!-- 跨职能 -->
                    <Select
                      v-model="formItem.crossFunList"
                      clearable
                      multiple
                      v-if="isRefreash"
                    >
                      <Option
                        v-for="item in ChinaGroupType"
                        :value="item.code"
                        :key="item.code"
                        >{{
                          lang == "zh" ? item.ch_value : item.en_value
                        }}</Option
                      >
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row :gutter="80">
                <Col :xs="24" :sm="24" :md="24" :lg="24">
                  <FormItem
                    :label="$t('Specify')"
                    :label-width="140"
                    v-if="formCheck"
                    ><!-- 具体说明 -->
                    <Input
                      v-model="formItem.details"
                      type="textarea"
                      :rows="4"
                    />
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Panel>
      <!-- (status >= 5 && (userDeptFlag == 2 || userDeptFlag == 4)) ||
            (userDeptFlag == 1 && status >= 6) -->
      <Panel
        name="4"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-if="
          (status >= 5 && (userDeptFlag == 2 || userDeptFlag == 4)) ||
          status >= 6
        "
      >
        <FormTitle
          :titleText="$t('Performance_Feedback_two')"
        /><!-- 绩效沟通 -->
        <div style="margin-top: 30px" slot="content">
          <div><!-- 绩效面谈 -->{{ $t("Performance_Feedback_") }}</div>
          <Divider />
          <div style="margin: 30px 0">
            <Form
              label-position="left"
              :model="formItem1"
              style="margin: 30px 5px 0 5px"
              :rules="ruleValidate1"
              ref="formValidate1"
            >
              <Row :gutter="40">
                <Col :xs="24" :sm="24" :md="24" :lg="24">
                  <!-- 面谈记录 -->
                  <FormItem
                    :label="$t('总体评价')"
                    :label-width="180"
                    v-if="formCheck"
                    :prop="
                      userDeptFlag == 2 || userDeptFlag == 4
                        ? 'interviewNotes'
                        : ''
                    "
                  >
                    <Input
                      v-model="formItem1.interviewNotes"
                      :disabled="
                        userDeptFlag == 1 ||
                        userDeptFlag == 3 ||
                        userDeptFlag == 10 ||
                        status == 6
                      "
                      type="textarea"
                      :rows="4"
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row :gutter="40">
                <Col :xs="24" :sm="24" :md="12" :lg="7">
                  <FormItem :label="$t('WHAT_Rating')" :label-width="180"
                    ><!-- “做什么”WHAT评分 -->
                    <Input v-model="formItem1.whatScore" disabled />
                  </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="12" :lg="7">
                  <FormItem :label="$t('HOW_Rating')" :label-width="180"
                    ><!-- 如何做HOW评分 -->
                    <Input v-model="formItem1.howScore" disabled />
                  </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="12" :lg="6">
                  <FormItem :label="$t('Overall_Rating')" :label-width="100"
                    ><!-- 整体评分 -->
                    <Input v-model="formItem1.wholeScore" disabled />
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </div>

          <div><!-- 员工确认 -->{{ $t("Employee_Confirmation") }}</div>
          <Divider />
          <div style="margin-top: 30px">
            <Form
              :label-width="260"
              :model="formItem1"
              label-position="left"
              style="margin: 30px 5px 0 5px"
              :rules="ruleValidate1"
              ref="formValidate2"
              :disabled="userDeptFlag != 1 || status < 6"
            >
              <Row :gutter="80">
                <Col :xs="24" :sm="24" :md="24" :lg="24">
                  <FormItem
                    :label="`1）我已知悉${userInfoa.year}年绩效结果`"
                    v-if="formCheck"
                    :prop="userDeptFlag == 1 ? 'beKnowResult' : ''"
                  >
                    <RadioGroup v-model="formItem1.beKnowResult">
                      <Radio label="1">是</Radio>
                      <Radio label="0">否</Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
              </Row>
              <Row :gutter="80">
                <Col :xs="24" :sm="24" :md="24" :lg="24">
                  <FormItem
                    :label="$t('longText24')"
                    v-if="formCheck"
                    :prop="userDeptFlag == 1 ? 'beManagerInterview' : ''"
                    ><!-- 2）经理是否有做绩效面谈 -->
                    <RadioGroup v-model="formItem1.beManagerInterview">
                      <Radio label="1">是</Radio>
                      <Radio label="0">否</Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Panel>
      <Panel
        name="5"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-show="userInfoa.id"
      >
        <FormTitle
          :titleText="$t('Approval_History') + '/' + $t('Action_History')"
        /><!-- 审批历史/操作履历 -->
        <div style="margin-top: 30px" slot="content">
          <Tabs type="card" name="sub-tabs">
            <TabPane :label="$t('Approval_History')" tab="sub-tabs" :index="1">
              <!-- 审批历史 -->
              <ApprovalHistory
                ref="ApprovalHistory"
                @pageChangeApproval="pageChangeApproval"
              ></ApprovalHistory>
            </TabPane>
            <TabPane :label="$t('Action_History')" tab="sub-tabs" :index="2"
              ><!-- 操作履历 -->
              <OperationHistory
                ref="OperationHistory"
                @pageChangeOperation="pageChangeOperation"
              ></OperationHistory>
            </TabPane>
          </Tabs>
        </div>
      </Panel>
    </Collapse>
    <div class="btnRight" style="padding-top: 20px" v-if="cardHid">
      <!-- <Button type="primary" class="btn" v-if="applyEditFlag=='0'||applyEditFlag=='2'" @click="importCG">{{$t('Import_Draft')}}</Button> -->
      <!-- <Button type="primary" class="btn" v-if="applyEditFlag=='0'||applyEditFlag=='2'" @click="saveCG">{{$t('Save_Draft')}}</Button> -->
      <Button
        type="primary"
        class="btn"
        :disabled="endYearBtnFlag"
        v-if="
          (applyEditFlag == '0' || applyEndSaveFlag == '2') &&
          status < 5 &&
          userDeptFlag != '10'
        "
        @click="submit"
        >{{ $t("saveandsubmit")
        }}<!-- 提交 --></Button
      >
      <Button
        type="primary"
        class="btn"
        :disabled="endYearBtnFlag"
        v-if="
          (userDeptFlag == 1 && status == 6) ||
          ((userDeptFlag == 2 || userDeptFlag == 4) && status == 5)
        "
        @click="submit"
        >{{ $t("Submit")
        }}<!-- 提交 --></Button
      >
      <!-- <Button type="primary" class="btn" v-if="!isHistory"  @click="QAClick">{{$t('Q&A')}}</Button> -->
      <Button
        type="primary"
        class="btn"
        v-if="isHistory && returnFlag"
        @click="returnApply"
        >{{ $t("Return")
        }}<!-- 返回 --></Button
      >
      <Button
        type="primary"
        class="btn"
        v-if="!isHistory && targetRevisionState"
        @click="targetRevision"
        >{{ $t("Objective_Revision")
        }}<!-- 目标修订 --></Button
      >
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>

    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
    <QAComponent ref="qaComponent"></QAComponent>
  </div>
</template>

<script>
import PersonalGoals from "./PersonalGoals";
import STIComponent from "./STIComponent";
import BehaviorExpectation from "./BehaviorExpectation";
import GrowthCulture from "./GrowthCulture";
import DevelopmentPlan from "./DevelopmentPlan";
import axios from "axios";
import QAComponent from "@/components/process/Apply/components/QAComponent";
import ApprovalHistory from "./ApprovalHistory";
import OperationHistory from "./OperationHistory";
export default {
  components: {
    PersonalGoals,
    STIComponent,
    BehaviorExpectation,
    DevelopmentPlan,
    QAComponent,
    ApprovalHistory,
    OperationHistory,
    GrowthCulture,
  },
  data() {
    return {
      value: [1, 2, 3, 4, 5, 6, 7],
      isHistory: false,
      isRefreash: true,
      formItem: {
        beInitiative: "",
        crossRegion: "",
        crossFunList: [],
        details: "",
      },
      formItem1: {
        interviewNotes: "",
        beKnowResult: "",
        beManagerInterview: "",
      },
      list: [{ value: 0, label: "value1" }],
      userInfo: {},
      userInfoa: {},
      spinShow: false,
      reportId: "",
      userDeptFlag: "",
      applyEditFlag: "",
      YesOrNoList: [],
      CrossRegional: [],
      ChinaGroupType: [],
      status: "",
      formCheck: true,
      qaId: "",
      endType: "",
      cardHid: true,
      endYearBtnFlag: false,
      targetUpdateButton: "",
      applyEndSaveFlag: "",
      targetRevisionState: true,
      returnFlag: false,
    };
  },
  watch: {
    userInfo(newVal, oldVal) {
      this.userInfoa = newVal;
    },
    lang(val) {
      this.isRefreash = false;
      this.$nextTick(() => {
        this.isRefreash = true;
      });
    },
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    ruleValidate() {
      return {
        beInitiative: [
          {
            required: true,
            message: this.$t("My_Performance_mess7"),
            trigger: "change",
          },
        ],
        crossRegion: [
          {
            required: true,
            message: this.$t("My_Performance_mess8"),
            trigger: "change",
          },
        ],
        crossFunList: [
          {
            type: "array",
            required: true,
            message: this.$t("My_Performance_mess9"),
            trigger: "change",
          },
        ],
        details: [
          {
            required: true,
            message: this.$t("My_Performance_mess10"),
            trigger: "blur",
          },
        ],
      };
    },

    ruleValidate1() {
      return {
        interviewNotes: [
          {
            required: true,
            message: this.$t("My_Performance_mess11"),
            trigger: "blur",
          },
        ],
        beKnowResult: [
          {
            required: true,
            message: this.$t("My_Performance_mess12"),
            trigger: "change",
          },
        ],
        beManagerInterview: [
          {
            required: true,
            message: this.$t("My_Performance_mess13"),
            trigger: "change",
          },
        ],
      };
    },
    //2026新内容是否生效
    isNCTE() {
      let flag = false;
      let nowDate = this.$nowDate.dateVal(new Date(), "YYYY");
      if (nowDate <= this.userInfo.year) {
        flag = true;
      }
      return flag;
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    getListData() {
      axios.post("/achApply/selectApplyAchLabel", {}).then((res) => {
        if (res) {
          this.YesOrNoList = res.YesOrNo;
          this.CrossRegional = res.CrossRegional;
          this.ChinaGroupType = res.ChinaGroupType;
        }
      });
    },
    getData() {
      this.spinShow = true;
      this.endYearBtnFlag = true;
      axios
        .post("/achApply/selectApplyDetails", {
          achStage: "年终总结",
          id: this.reportId,
          serialnumber: this.userInfoa.serialnumber,
          year: this.userInfoa.year,
        })
        .then((res) => {
          this.spinShow = false;
          this.endYearBtnFlag = false;

          // 1修订 2 设定
          if (res.targetUpdateFlag != "1" && res.targetUpdateFlag != "2") {
            // 状态为4 开始定时提醒
            if (
              (res.applyAchInfo.status == "4" ||
                res.applyAchInfo.status == "3" ||
                res.applyAchInfo.status == "2") &&
              (res.flagMap.userDeptFlag == "1" ||
                res.flagMap.userDeptFlag == "2" ||
                res.flagMap.userDeptFlag == "3" ||
                res.flagMap.userDeptFlag == "4")
            ) {
              this.$emit("beginTime", "1");
            } else {
              this.$emit("beginTime", "0");
            }
            this.endType = res.applyAchInfo.endType;
            this.$refs.PersonalGoals.data1 = res.achKeyNoteInfoList;
            this.$refs.STIComponent.data1 = res.stiTargetInfoList;
            let list = res.expectInfoList;
            let array = [];
            if (list.length > 0) {
              this.$refs.BehaviorExpectation.data5.forEach((element) => {
                list.forEach((item) => {
                  if (element.criterionType == item.criterionType) {
                    array.push({ ...element, ...item });
                  }
                });
              });
              this.$refs.BehaviorExpectation.data5 = array;
            }

            // 2025追加增长文化
            let growthlist = res.growthCultureList;
            let growthArray = [];
            if (growthlist.length > 0) {
              this.$refs.GrowthCulture.data5.forEach((element) => {
                growthlist.forEach((item) => {
                  if (element.criterionType == item.criterionType) {
                    growthArray.push({ ...element, ...item });
                  }
                });
              });
              this.$refs.GrowthCulture.data5 = growthArray;
              this.setGrowthCultureData();
            }

            this.$refs.DevelopmentPlan.data5 = res.developmentPlanList;
            if (res.applyAchInfo.empCode) {
              this.userInfoa = res.applyAchInfo;
              this.formItem.beInitiative = res.applyAchInfo.beInitiative;
              this.formItem.crossRegion = res.applyAchInfo.crossRegion;
              this.formItem.crossFun = res.applyAchInfo.crossFun;
              this.formItem.crossFunList = res.applyAchInfo.crossFun
                ? res.applyAchInfo.crossFun.split(",")
                : [];
              console.log("YESYES");
              this.formItem.details = res.applyAchInfo.details;
              this.status = res.applyAchInfo.status;
              this.$refs.DevelopmentPlan.status = res.applyAchInfo.status;
              this.$refs.PersonalGoals.status = res.applyAchInfo.status;
              this.$refs.STIComponent.status = res.applyAchInfo.status;
              this.$refs.BehaviorExpectation.status = res.applyAchInfo.status;
              this.$refs.GrowthCulture.status = res.applyAchInfo.status;
            }
            res.applyAchInfo.status
              ? (this.userInfoa.status = res.applyAchInfo.status)
              : "";
            res.interviewInfo ? (this.formItem1 = res.interviewInfo) : "";
            this.formCheckChange();
            this.$refs.PersonalGoals.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.STIComponent.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.BehaviorExpectation.applyEditFlag =
              res.flagMap.applyEditFlag;
            this.$refs.DevelopmentPlan.applyEditFlag =
              res.flagMap.applyEditFlag;
            this.$refs.PersonalGoals.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.STIComponent.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.BehaviorExpectation.userDeptFlag =
              res.flagMap.userDeptFlag;
            // 2025 追加传入 增长文化赋值字段
            this.$refs.GrowthCulture.applyEditFlag = res.flagMap.applyEditFlag;
            this.$refs.DevelopmentPlan.userDeptFlag = res.flagMap.userDeptFlag;
            this.$refs.GrowthCulture.userDeptFlag = res.flagMap.userDeptFlag;
            this.targetUpdateButton = res.flagMap.targetUpdateButton;
            this.$refs.PersonalGoals.getMidData();
            this.$refs.STIComponent.getMidData();
            this.$refs.BehaviorExpectation.getMidData();
            this.$refs.DevelopmentPlan.getMidData();
            this.$refs.GrowthCulture.getMidData();
            this.userDeptFlag = res.flagMap.userDeptFlag;
            this.applyEditFlag = res.flagMap.applyEditFlag;
            this.applyEndSaveFlag = res.flagMap.applyEndSaveFlag;

            if (res.applyAchInfo.id) {
              this.getApprovalData();
              this.getOperationData();
            }
          } else {
            this.$Modal.warning({
              title:
                res.targetUpdateFlag == "1"
                  ? this.$t("warningFinesh1")
                  : this.$t("warningFinesh2"),
              onOk: () => {
                this.$emit("addModalWarning");
              },
            });
          }
        });
    },
    setGrowthCultureData() {
      if (!this.isNCTE && this.$refs.GrowthCulture.data5.length > 0) {
        let allExpectDetails = "";
        let allEmpDetails = "";
        let allIndirSupFeedback = "";
        let allDirSupFeedback = "";
        this.$refs.GrowthCulture.data5.map((item) => {
          if (item.expectDetails) {
            allExpectDetails += item.expectDetails + ";\n";
          }
          if (item.empDetails) {
            allEmpDetails += item.empDetails + ";\n";
          }
          if (item.indirSupFeedback) {
            allIndirSupFeedback += item.indirSupFeedback + ";\n";
          }
          if (item.dirSupFeedback) {
            allDirSupFeedback += item.dirSupFeedback + ";\n";
          }
        });
        this.$refs.GrowthCulture.data5[0].expectDetails = allExpectDetails;
        this.$refs.GrowthCulture.data5[0].empDetails = allEmpDetails;
        this.$refs.GrowthCulture.data5[0].indirSupFeedback =
          allIndirSupFeedback;
        this.$refs.GrowthCulture.data5[0].dirSupFeedback = allDirSupFeedback;
      }
    },
    getApprovalData() {
      axios
        .post("/achReport/selectApprovalHistoryList ", {
          achStage: "年终总结",
          id: this.userInfoa.id,
          ...this.$refs.ApprovalHistory.pageInfo,
        })
        .then((res) => {
          this.$refs.ApprovalHistory.data = res.data;
          this.$refs.ApprovalHistory.total = parseInt(res.pageInfo.total);
        });
    },
    getOperationData() {
      axios
        .post("/achReport/selectOperationHistoryList", {
          achStage: "年终总结",
          id: this.userInfoa.id,
          ...this.$refs.OperationHistory.pageInfo,
        })
        .then((res) => {
          this.$refs.OperationHistory.data = res.data;
          this.$refs.OperationHistory.total = parseInt(res.pageInfo.total);
        });
    },
    pageChangeApproval(item) {
      this.getApprovalData();
    },
    pageChangeOperation(item) {
      this.getOperationData();
    },
    importCG() {
      this.$refs.cgTem.getInternation();
      //草稿type 操作人
      this.$refs.cgTem.popShow(
        "ACH01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      );
    },
    saveCG() {
      this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
      let obj = {
        applyAchInfo: this.formItem,
        interviewInfo: this.formItem1,
        achKeyNoteInfoList: this.$refs.PersonalGoals.data1,
        stiTargetInfoList: this.$refs.STIComponent.data1,
        expectInfoList: this.$refs.BehaviorExpectation.data5,
        developmentPlanList: this.$refs.DevelopmentPlan.data5,
      };
      this.$refs.cgPop.popShow("ACH01", { formItem: obj });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      this.spinShow = true;
      var obj = JSON.parse(row.draftContent);
      this.$refs.PersonalGoals.data1 = obj.formItem.achKeyNoteInfoList;
      this.$refs.PersonalGoals.tableSpan();
      this.$refs.STIComponent.data1 = obj.formItem.stiTargetInfoList;
      let list = obj.formItem.expectInfoList;
      let array = [];
      if (list.length > 0) {
        this.$refs.BehaviorExpectation.data5.forEach((element) => {
          list.forEach((item) => {
            if (element.criterionType == item.criterionType) {
              array.push({ ...element, ...item });
            }
          });
        });
        this.$refs.BehaviorExpectation.data5 = array;
      }
      this.$refs.DevelopmentPlan.data5 = obj.formItem.developmentPlanList;
      this.formItem = obj.formItem.applyAchInfo;
      this.formItem1 = obj.formItem.interviewInfo;
      this.$nextTick(() => {
        setTimeout(() => {
          this.spinShow = false;
        }, 1000);
      });
    },
    submit() {
      this.userInfoa = { ...this.userInfoa, ...this.userInfo };
      this.endYearBtnFlag = true;
      if (this.status == 5 && this.userDeptFlag == 2) {
        this.$refs.formValidate1.validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$Message.error("请填写必填项");
            this.endYearBtnFlag = false;
          }
        });
      } else if (this.status == 6 && this.userDeptFlag == 1) {
        this.$refs.formValidate2.validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$Message.error("请填写必填项");
            this.endYearBtnFlag = false;
          }
        });
      } else if (this.status < 5 && this.userDeptFlag == 1) {
        this.$refs.formValidate.validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$Message.error("请填写必填项");
            this.endYearBtnFlag = false;
          }
        });
      } else {
        this.save();
        console.log(this.userInfoa, "this.userInfoa");
      }
    },
    save() {
      // 将能动性 中国区总部 存一个 String类型的值
      if (this.formItem.crossFunList.length > 0) {
        this.formItem.crossFun = this.formItem.crossFunList.join(",");
      }
      let growthCultureList = JSON.parse(
        JSON.stringify(this.$refs.GrowthCulture.data5)
      );
      let growthCultureInfo1 = growthCultureList[0] || {};
      growthCultureList.map((item) => {
        item.expectDetails = growthCultureInfo1.expectDetails;
        item.empDetails = growthCultureInfo1.empDetails;
        item.indirSupFeedback = growthCultureInfo1.indirSupFeedback;
        item.dirSupFeedback = growthCultureInfo1.dirSupFeedback;
      });
      let obj = {
        achStage: "年终总结",
        createUser: JSON.parse(sessionStorage.getItem("userInfo")).serialnumber,
        applyAchInfo: {
          ...(this.userInfoa || this.userInfo),
          ...this.formItem,
          // serialnumber:this.userInfo.serialnumber,
          applyUserName: this.userInfoa.userName || this.userInfo.userName,
          beReport: "0",
          achTypeUser: this.userInfoa.achTypeUser,
        },
        interviewInfo: this.formItem1,
        achKeyNoteInfoList: this.$refs.PersonalGoals.data1,
        stiTargetInfoList: this.$refs.STIComponent.data1,
        expectInfoList: this.$refs.BehaviorExpectation.data5,
        developmentPlanList: this.$refs.DevelopmentPlan.data5,
        growthCultureList: growthCultureList,
      };
      this.spinShow = true;
      axios
        .post("/achApply/saveAchApplyInfo", obj)
        .then((res) => {
          this.spinShow = false;
          this.endYearBtnFlag = false;
          if (res) {
            this.$Message.success(res);
            this.getData(this.userInfoa);
          }
        })
        .catch(() => {
          this.$Message.error({
            content: "系统异常,提交未成功,请稍后尝试提交。",
            duration: 5,
          });
          this.spinShow = false;
          this.endYearBtnFlag = false;
        });
    },
    returnApply() {
      this.$router.back();
    },
    formCheckChange() {
      this.formCheck = false;
      this.$nextTick(() => {
        this.formCheck = true;
      });
    },
    QAClick() {
      this.$refs.qaComponent.QAModal = true;
      this.$refs.qaComponent.getUserList();
      this.qaId != "" ? (this.$refs.qaComponent.qaId = this.qaId) : "";
    },
    QAData(val) {
      this.qaId = val;
    },
    targetRevision() {
      if (this.targetUpdateButton != "1") {
        if (this.targetUpdateButton == "2") {
          this.$Message.info(this.$t("My_Performance_mess4"));
          return;
        } else {
          this.$Message.info(this.$t("My_Performance_mess5"));
          return;
        }
      }
      if (this.userInfoa.status < 2 || this.userInfoa.status == 90) {
        this.$Message.info(this.$t("My_Performance_mess6"));
        return;
      }
      if (this.userInfoa.status == 8 || this.userInfoa.status == 9) {
        this.$Message.info(this.$t("STIUpdateCheck"));
        return;
      }
      this.targetRevisionState = false;
      this.$emit("targetRevision", true);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.ivu-divider-horizontal {
  margin: 10px 0 24px 0;
}

.btnRight {
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  padding-bottom: 15px;
  left: 220px;
  z-index: 99;
  box-shadow: 0px -5px 10px -2px rgba(0, 0, 0, 0.2);
  .btn {
    margin-right: 15px;
    // margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/YearEndSummary.vue